import { groupRolePermission } from '@/module/user-permission/helper';
import customToast from '@/new-components/CustomNotification';
import { renderGroupMenu } from '@/new-components/CustomSidebarMenu/renderGroupMenu';
import { synthesize } from 'redux-dispatcher';

const mapDispatchToAC = {
  getState: (name, data) => ({ [name]: data }),
  getAllPermissions:
    () =>
    async ({ Api }) => {
      let { result, status } = await Api.get(`permissions`);
      status === 200 &&
        roleManagementDispatcher.getState('permissions', result);
    },
  getAllRoles:
    (callback) =>
    async ({ Api }) => {
      let { result, status } = await Api.get(`permissions/roles`);
      status === 200 && roleManagementDispatcher.getState('roles', result);
    },
  getAllConfigs:
    () =>
    async ({ Api }) => {
      let { result, status } = await Api.get(`permissions/configs`);
      status === 200 && roleManagementDispatcher.getState('configs', result);
    },

  getUserPermissions:
    () =>
    async ({ Api }) => {
      const { result, status } = await Api.get(`permissions/by-user`);

      if (status === 200) {
        const groupedPermission = groupRolePermission(
          result,
          renderGroupMenu()
        );
        roleManagementDispatcher.getUserPermissionSuccess(groupedPermission);
        roleManagementDispatcher.getState('userPermission', result);
      }
    },
  getUserPermissionSuccess: (groupedPermission) => ({
    groupedPermission,
  }),
  updateRolePermissions:
    (rolePermissions, callback) =>
    async ({ Api }) => {
      let { status } = await Api.put(`permissions/configs`, {
        rolePermissions,
      });
      if (status === 200) {
        callback();
        customToast('success', 'Update permission successful');
      }
    },
  clearPermission: (payload) => ({ payload }),
};

const roleManagementDispatcher = synthesize('roleManagement', mapDispatchToAC);
export default roleManagementDispatcher;
